import {useTranslation} from '@/translations/i18n'
import {Avatar} from '@components/ui/avatar'
import {usePhotographersMe} from '@features/user/queries/usePhotographersMe'
import {Spinner} from '@components/ui/spinner'

export const ConfirmAccountSection = () => {
    const {t} = useTranslation()
    const photographersMeQuery = usePhotographersMe()

    return (
        <div className="flex flex-col gap-8 text-center [&_h2]:text-display-sm [&_h2]:font-medium [&_p]:text-lg [&_p]:text-neutral-700">
            <div className="flex flex-col items-center justify-center gap-3">
                <h2>{t('link_airbnb_account:confirm_title')}</h2>
                <p>{t('link_airbnb_account:confirm_description')}</p>
            </div>

            <div className="flex h-full min-h-[146px] w-full flex-col items-center justify-center gap-2 rounded-2xl border border-neutral-300 p-4 [&_p]:text-xl [&_p]:font-medium [&_p]:text-neutral-900 [&_span]:text-neutral-700">
                {photographersMeQuery.isPending ? (
                    <Spinner size={36} />
                ) : (
                    <>
                        <Avatar
                            name={photographersMeQuery.data?.user.first_name ?? ''}
                            imageUrl={photographersMeQuery.data?.user.picture_url ?? ''}
                            size="lg"
                        />
                        <div className="flex flex-col items-center">
                            <p>{photographersMeQuery.data?.user.first_name}</p>
                            <span>{photographersMeQuery.data?.user.email}</span>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}
ConfirmAccountSection.displayName = 'ConfirmAccountSection'
